<template>
    <transition name="modal">
        <div class="modal-mask">
            <div class="modal-wrapper flexbox-center">
                <div v-if="modalType !== 'handler'" class="modal-container" :class="{'modal-small': modalSmall}">
                    <button type="button" @click="closeModal" class="close-button">
                        <span aria-hidden="true" tabindex="-1">×</span>
                    </button>
                    <div class="modal-body">
                        <slot name="body">
                            <component :is="selectedView" @close="closeModal" :data="modalData"></component>
                        </slot>
                    </div>
                </div>
                <div v-show="modalType === 'handler'" class="modal-container small-modal">
                    <h4 class="text-center black">
                        {{modalData}}
                    </h4>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
export default {
  name: "custom-modal",
  props: ["modalType", "modalData", "modalSmall"],
  data() {
    return {
      selectedView: null
    };
  },
  methods: {
    closeModal() {
      this.$emit("close");
    }
  },
  created() {
    this.selectedView = this.modalType;
  }
};
</script>
